import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetComplaintsResponse,
    GetComplaintsParams,
    GetComplaintIdResponse,
    AgreeComplaintParams,
    ComplaintsExportExcelResponse,
} from './types/complaints'

type ApiGetComplaintsResponse = Promise<AxiosResponse<GetComplaintsResponse>>
type ApiGetComplaintIdResponse = Promise<AxiosResponse<GetComplaintIdResponse>>
type ApiAgreeComplaintResponse = Promise<AxiosResponse<void>>
type ApiChangeComplaintStatusResponse = Promise<AxiosResponse<void>>
type ApiExportExcelResponse = Promise<AxiosResponse<ComplaintsExportExcelResponse>>

export function getList(params: GetComplaintsParams): ApiGetComplaintsResponse {
    return http.get('/cabinet/api/admin/complaint', { params })
}

export function getComplaint(id: number): ApiGetComplaintIdResponse {
    return http.get(`/cabinet/api/admin/complaint/${id}`, { params: { id } })
}

export function agreeComplaint(
    id: number,
    payload: AgreeComplaintParams
): ApiAgreeComplaintResponse {
    return http.put(`/cabinet/api/admin/complaint/${id}/agreement`, payload)
}

export function addComplaint(payload: FormData): ApiAgreeComplaintResponse {
    return http.postFormData('/cabinet/api/admin/complaint', payload)
}

export function changeComplaintStatus(
    id: number,
    statusId: number
): ApiChangeComplaintStatusResponse {
    return http.put(`/cabinet/api/admin/complaint/${id}/change-status`, { statusId })
}

export function exportExcel(): ApiExportExcelResponse {
    return http.get('/cabinet/api/admin/complaint/export', { responseType: 'blob' })
}

export default {
    getList,
    getComplaint,
    agreeComplaint,
    addComplaint,
    changeComplaintStatus,
    exportExcel,
}
